var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckboxC(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_163_24804)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    rx: 4,
    fill: "#FF6C7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8695 8.02424L10.5142 18.3558C10.4314 18.4481 10.3186 18.5 10.2009 18.5C10.0832 18.5 9.97045 18.4481 9.88759 18.3558L5.13053 13.1023C5.04699 13.0108 5 12.8863 5 12.7563C5 12.6264 5.04699 12.5018 5.13053 12.4103L5.74833 11.728C5.83119 11.6358 5.94398 11.5839 6.06164 11.5839C6.17931 11.5839 6.2921 11.6358 6.37496 11.728L10.1965 15.9484L18.625 6.6402C18.7996 6.45327 19.0771 6.45327 19.2517 6.6402L19.8695 7.33222C19.953 7.42372 20 7.54829 20 7.67823C20 7.80817 19.953 7.93273 19.8695 8.02424Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_163_24804"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    rx: 4,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxC);
export default __webpack_public_path__ + "static/media/Checkbox-c.6d539e27cb5dbb41c0906ee79e78d2d4.svg";
export { ForwardRef as ReactComponent };